import React, { Fragment, useEffect, useState } from "react"

import { Field, useFormikContext } from "formik"
import validator from "validator"
import { MAX_INPUT_LIMIT } from "../../../../utilities/constants.js"
import {
  FIELD_TYPES,
  OTHER_OPTION_PLACEHOLDER_VALUE,
  OTHER_OPTION_VALIDATION_ERROR_MESSAGE,
  validTextEntryMatchRegex,
  validTextErrorMessage,
} from "../dynamic-form.constants"
import { getInNested } from "../dynamic-form.helper"
import InputText from "./input-text"

function InputCheckbox(props) {
  const { id, label, name, rows, optionData, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { values, touched, errors } = useFormikContext()
  const [optionList, setOptionList] = useState([])
  const normalizedFieldName = isNestedFieldName ? name : `['${name}']`
  const hasOtherOption = () => {
    return optionList.find((option) => option.display?.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase())
  }

  useEffect(() => {
    const tempOptionList = [...optionData]
    if (fieldData && optionData && Array.isArray(optionData)) {
      if (
        fieldData.type === FIELD_TYPES.MULTI_OPTIONS_WITH_STRING_OTHER &&
        !optionData.find((option) => option.display?.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase())
      ) {
        tempOptionList.push({
          display: OTHER_OPTION_PLACEHOLDER_VALUE,
          value: OTHER_OPTION_PLACEHOLDER_VALUE,
        })
      }
      setOptionList(tempOptionList)
    }
  }, [optionData, fieldData])

  const getOtherOptionView = ({ propName, rows }) => {
    const otherOptionTextName = `other_${propName}`
    const fieldValues = getInNested(values, name, isNestedFieldName)
    if (
      fieldValues &&
      Array.isArray(fieldValues) &&
      fieldValues.find((value) => value.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase())
    ) {
      let error_message = OTHER_OPTION_VALIDATION_ERROR_MESSAGE
      if (!values[otherOptionTextName]) {
        errors[otherOptionTextName] = error_message
      } else if (!validator.matches(values[otherOptionTextName], validTextEntryMatchRegex)) {
        error_message = validTextErrorMessage
        errors[otherOptionTextName] = error_message
      } else if (!validator.isLength(values[otherOptionTextName], { max: MAX_INPUT_LIMIT })) {
        error_message = `Value must be ${MAX_INPUT_LIMIT} characters or less.`
        errors[otherOptionTextName] = error_message
      } else {
        delete errors[otherOptionTextName]
      }
      return (
        <InputText
          id={`other-${id}`}
          label="Other"
          name={otherOptionTextName}
          placeholder="Enter a value"
          rows={rows}
          errorMessage={error_message}
          isRequired={true}
        ></InputText>
      )
    } else {
      values[otherOptionTextName] = ""
      delete errors[otherOptionTextName]
      return null
    }
  }
  return (
    <Fragment>
      <div className="custom-form-block">
        {/* Honor the shared `enabled === false` disable convention used by every other
            dynamic-form renderer (input-text/select/radio all wrap in a disabled
            <fieldset>). Inert when `enabled` is undefined. Also render `fieldData.comments`
            as the explanation so a gated field (e.g. the CTF coordinator toggle on a
            scenario that fails the question contract) tells the facilitator WHY. */}
        <fieldset disabled={fieldData?.enabled === false}>
          <label htmlFor={id} className="form-label mt-2">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="c-checkbox-groups flex-grow-1" role="group">
            {optionList &&
              Array.isArray(optionList) &&
              optionList.map((option, option_index) => (
                <div className="form-check form-check-inline" key={`${id}-option-${option_index}`}>
                  <Field
                    type="checkbox"
                    name={normalizedFieldName}
                    id={`option-${id}-${option_index}`}
                    className={`form-check-input`}
                    checked={
                      getInNested(values, name, isNestedFieldName) && getInNested(values, name, isNestedFieldName).includes(option.value)
                        ? true
                        : false
                    }
                    value={option.value}
                    // `uncheckOnly`: an unticked option can't be ticked, a ticked one can still be cleared
                    // (e.g. CTF on a scenario that fails the question contract).
                    disabled={fieldData?.uncheckOnly === true && !getInNested(values, name, isNestedFieldName)?.includes?.(option.value)}
                    {...otherProps}
                  ></Field>
                  <label htmlFor={`option-${id}-${option_index}`} className="form-check-label">
                    {option.display}
                  </label>
                </div>
              ))}
          </div>
          {fieldData?.comments && <div className="form-text field-comments">{fieldData.comments}</div>}
          <div className="invalid-feedback">
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </fieldset>
      </div>

      {hasOtherOption() && (
        <div className="col-12" style={{ paddingRight: "12px" }}>
          {getOtherOptionView({ propName: name, rows })}
        </div>
      )}
    </Fragment>
  )
}

InputCheckbox.propTypes = {}

export default InputCheckbox
